import { render, staticRenderFns } from "./addChainSupplier.vue?vue&type=template&id=2a41cf7f&scoped=true"
import script from "./addChainSupplier.vue?vue&type=script&lang=js"
export * from "./addChainSupplier.vue?vue&type=script&lang=js"
import style0 from "./addChainSupplier.vue?vue&type=style&index=0&id=2a41cf7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41cf7f",
  null
  
)

export default component.exports